import { makeClassName } from '@siteless/util';
import { BaseContainerComponentPropsType } from '../util/types';

export let Header = ({
  children,
  className,
}: BaseContainerComponentPropsType) => (
  <div className={makeClassName(className, 'font-medium text-xl text-left')}>
    {children}
  </div>
);
